module.exports = __webpack_public_path__ + "img/zygh_icon.5a1de17d.png";